import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import { CustomState } from "@tggstore/Store/Reducers";

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

replaceInChain(chain, PopulateApiParameter, props => {
    if (!props.cartToUpdate) {
        return;
    }

    const {
        pages: {
            onePageCheckout: { requestedDeliveryDate, requestedPickupDate },
        },
        customTransactionType: { transactionType }, // Verndale Customization ticket:   TGGOPT-1689
    } = props.getState() as CustomState;

    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined"
            ? requestedDeliveryDate
            : props.cartToUpdate.requestedDeliveryDateDisplay;
    const tempPickupDate =
        typeof requestedPickupDate !== "undefined"
            ? requestedPickupDate
            : props.cartToUpdate.requestedPickupDateDisplay;

    props.apiParameter = {
        cart: {
            ...props.cartToUpdate,
            requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
            requestedPickupDate: convertDateToApiFormat(tempPickupDate),
            properties: {
                transactionType: `${transactionType.id}`, // Verndale Customization ticket:   TGGOPT-1689
            },
        },
    };
});
